var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.getData,
                  expression: "getData"
                }
              ],
              staticClass: "main history_main",
              attrs: {
                "infinite-scroll-delay": "200",
                "infinite-scroll-distance": "100"
              }
            },
            [
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "div",
                    { staticClass: "filter" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _c("h4", [_vm._v("选择客户")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.customerChange },
                                  model: {
                                    value: _vm.customerValue,
                                    callback: function($$v) {
                                      _vm.customerValue = $$v
                                    },
                                    expression: "customerValue"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "全部", value: "全部" }
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.customerData, function(item) {
                                    return _c("el-option", {
                                      key: item.number,
                                      attrs: {
                                        label: item.number + item.client_name,
                                        value: item.client_name
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _c("h4", [_vm._v("效果类型")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.typeChange },
                                  model: {
                                    value: _vm.typeValue,
                                    callback: function($$v) {
                                      _vm.typeValue = $$v
                                    },
                                    expression: "typeValue"
                                  }
                                },
                                _vm._l(_vm.typeOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 4, offset: 2 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    icon: "el-icon-right",
                                    type: "success"
                                  },
                                  on: { click: _vm.toCollect }
                                },
                                [
                                  _c("span", { staticClass: "btn" }, [
                                    _vm._v("收藏的效果图")
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.renderData, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: item.effect_id,
                        class: ["clientBox", { failed: item.status === 2 }]
                      },
                      [
                        _c("div", { staticClass: "sub" }, [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(item.client_name))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "space_name" }, [
                            _vm._v(_vm._s(item.space_type))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "style_name" }, [
                            _vm._v(_vm._s(item.style_type))
                          ]),
                          _vm._v(" "),
                          item.status === 2
                            ? _c("span", { staticClass: "status_failed" }, [
                                _vm._v("生成失败")
                              ])
                            : item.status === 0
                            ? _c("span", { staticClass: "status_pending" }, [
                                _vm._v("生成中")
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "date" }, [
                          _vm._v(_vm._s(item.createtime))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: ["mediaBox", _vm.getMediaBoxClass(item)] },
                          [
                            item.type === 3
                              ? [
                                  item.description
                                    ? _c(
                                        "div",
                                        { staticClass: "item prompt_item" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "prompt_text" },
                                            [_vm._v(_vm._s(item.description))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "mediaName" },
                                            [_vm._v("提示词")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                item.effect_result[0].file_url +
                                                "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                              alt: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : item.type === 0
                              ? [
                                  item.photo_url
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.photo_url +
                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetailImg(index, 0)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mediaName" },
                                          [_vm._v("毛坯图")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.style_photo_url
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.style_photo_url +
                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetailImg(index, 2)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mediaName" },
                                          [_vm._v("参考图")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                item.effect_result[0].file_url +
                                                "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                              alt: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : item.type === 1
                              ? [
                                  item.photo_url
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.photo_url +
                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetailImg(index, 0)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mediaName" },
                                          [_vm._v("原图")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                item.effect_result[0].file_url +
                                                "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                              alt: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : item.type === 4
                              ? [
                                  item.photo_url
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.photo_url +
                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetailImg(index, 0)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mediaName" },
                                          [_vm._v("平面图")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                item.effect_result[0].file_url +
                                                "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                              alt: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : item.type === 5
                              ? [
                                  item.photo_url
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.photo_url +
                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetailImg(index, 0)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mediaName" },
                                          [_vm._v("平面图")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                item.effect_result[0].file_url +
                                                "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                              alt: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : item.type === 2
                              ? [
                                  item.photo_url
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.photo_url +
                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetailImg(index, 0)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mediaName" },
                                          [_vm._v("首帧")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.end_photo_url
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.end_photo_url +
                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetailImg(index, 2)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mediaName" },
                                          [_vm._v("尾帧")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("video", {
                                            attrs: {
                                              src:
                                                item.effect_result[0].file_url,
                                              poster:
                                                item.photo_url +
                                                "?x-oss-process=image/resize,m_fill,w_1000,h_1000"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "play" }, [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../assets/ico_play.png"),
                                                alt: ""
                                              }
                                            })
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : item.type === 6
                              ? [
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("video", {
                                            attrs: {
                                              src:
                                                item.effect_result[0].file_url
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "play" }, [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../assets/ico_play.png"),
                                                alt: ""
                                              }
                                            })
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : item.type === 7
                              ? [
                                  item.description
                                    ? _c(
                                        "div",
                                        { staticClass: "item prompt_item" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "prompt_text" },
                                            [_vm._v(_vm._s(item.description))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "mediaName" },
                                            [_vm._v("提示词")]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          _c("video", {
                                            attrs: {
                                              src:
                                                item.effect_result[0].file_url
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "play" }, [
                                            _c("img", {
                                              attrs: {
                                                src: require("../../assets/ico_play.png"),
                                                alt: ""
                                              }
                                            })
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : [
                                  item.photo_url
                                    ? _c("div", { staticClass: "item" }, [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              item.photo_url +
                                              "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                            alt: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetailImg(index, 0)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mediaName" },
                                          [_vm._v("原图")]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.effect_result.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "item",
                                          on: {
                                            click: function($event) {
                                              return _vm.toDetail(index)
                                            }
                                          }
                                        },
                                        [
                                          item.effect_result[0].file_type != 1
                                            ? _c("img", {
                                                attrs: {
                                                  src:
                                                    item.effect_result[0]
                                                      .file_url +
                                                    "?x-oss-process=image/resize,m_fill,w_1000,h_1000",
                                                  alt: ""
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.effect_result[0].file_type == 1
                                            ? _c("video", {
                                                attrs: {
                                                  src:
                                                    item.effect_result[0]
                                                      .file_url,
                                                  poster:
                                                    item.photo_url +
                                                    "?x-oss-process=image/resize,m_fill,w_1000,h_1000"
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "type" }, [
                                            _vm._v(
                                              _vm._s(_vm.getTypeName(item.type))
                                            )
                                          ]),
                                          _vm._v(" "),
                                          item.effect_result[0].file_type == 1
                                            ? _c(
                                                "div",
                                                { staticClass: "play" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/ico_play.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                          ],
                          2
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "btn_top",
                    on: { click: _vm.toTop }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.dialogVisible == "detail_img"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        "custom-class": "pop_img",
                        visible: _vm.dialogVisit,
                        top: "15vh",
                        "show-close": false,
                        center: true,
                        beforeClose: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _vm.dialogImg != ""
                        ? _c("div", { staticClass: "img" }, [
                            _c("img", {
                              attrs: { src: _vm.dialogImg, alt: "" }
                            })
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogVisible == "detail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        width: "70%",
                        "show-close": true,
                        center: ""
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "detail_box row",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c("el-col", { attrs: { span: 14 } }, [
                            _vm.dialogCur != -1
                              ? _c("div", { staticClass: "img" }, [
                                  _vm.renderData[_vm.dialogCur].effect_result[0]
                                    .file_type == 0
                                    ? _c("img", {
                                        attrs: {
                                          src:
                                            _vm.renderData[_vm.dialogCur]
                                              .effect_result[0].file_url,
                                          alt: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toDetailImg(
                                              _vm.dialogCur,
                                              1
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.renderData[_vm.dialogCur].effect_result[0]
                                    .file_type == 1
                                    ? _c("video", {
                                        attrs: {
                                          src:
                                            _vm.renderData[_vm.dialogCur]
                                              .effect_result[0].file_url,
                                          poster: _vm.renderData[_vm.dialogCur]
                                            .photo_url
                                            ? _vm.renderData[_vm.dialogCur]
                                                .photo_url
                                            : "",
                                          alt: "",
                                          controls: "",
                                          controlsList: "nodownload"
                                        }
                                      })
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 10 } }, [
                            _c("div", { ref: "listBox", staticClass: "list" }, [
                              _c("div", { staticClass: "item title" }, [
                                _vm._v("参数")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("创作时间")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content" }, [
                                  _vm._v(_vm._s(_vm.detailData.createtime))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("空间类型")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content" }, [
                                  _vm._v(_vm._s(_vm.detailData.space_type))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("创作风格")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content" }, [
                                  _vm._v(_vm._s(_vm.detailData.style_type))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("AI大模型")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content" }, [
                                  _vm._v(_vm._s(_vm.detailData.model_name))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("风格强度")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content" }, [
                                  _vm._v(_vm._s(_vm.detailData.style_percent))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v("描述强度")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content" }, [
                                  _vm._v(
                                    _vm._s(_vm.detailData.description_percent)
                                  )
                                ])
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticClass: "tool", attrs: { gutter: 20 } },
                        [
                          _vm.detailData.effect_result[0].workblank_id == 0
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-picture",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toPath("/effectvideo")
                                        }
                                      }
                                    },
                                    [_vm._v("图生视频")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.detailData.effect_result[0].workblank_id == 0
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-first-aid-kit",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toPath("/effectaiedit")
                                        }
                                      }
                                    },
                                    [_vm._v("AI改图")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.detailData.effect_result[0].workblank_id == 0
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "success",
                                        icon:
                                          _vm.renderData[_vm.dialogCur]
                                            .effect_result[0].favorite == 0
                                            ? "el-icon-star-off"
                                            : "el-icon-star-on",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toFavorite(_vm.dialogCur)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.renderData[_vm.dialogCur]
                                            .effect_result[0].favorite == 0
                                            ? "收藏"
                                            : "取消收藏"
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              attrs: {
                                span:
                                  _vm.detailData.effect_result[0]
                                    .workblank_id == 0
                                    ? 6
                                    : 24
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    icon: "el-icon-download",
                                    plain: ""
                                  },
                                  on: { click: _vm.toDownload }
                                },
                                [_vm._v("下载")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-401337b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-401337b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Effect/History.vue
// module id = null
// module chunks = 